import logger from '@utils/logs';
import { useEffect } from 'react';

export const usePushNotification = () => {
    const requestPermission = async (): Promise<void> => {
        if (!('Notification' in window)) {
            logger.log('hooks > usePushNotification > this browser does not support notifications');
            return;
        }

        await Notification.requestPermission();
    };

    const showNotification = (title: string, description: string, onClick?: () => void): void => {
        logger.log('hooks > usePushNotification > showNotification', { title, description });

        const notification = new Notification(title, { body: description });

        if (onClick) {
            notification.onclick = onClick;
        }
    };
   
    useEffect(() => {
        logger.log('hooks > usePushNotification > requesting notifications permission');
        requestPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
        
    return {
        showNotification,
    };
};
